// Module
var code = "<div class=\"component-editor-source\">\n  <steps>\n    <step ng-model=\"connectionStep\"></step>\n    <step ng-model=\"componentFormStep\"></step>\n    <step ng-model=\"schemaImporterStep\"></step>\n  </steps>\n</div>\n";
// Exports
module.exports = code;